import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disp-menu-button__img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "disp-menu-button__txt" }, " 全画面解除 ", -1)


import dispMenuIcon from "@/../public/icon/index/icon-tool-btn-12.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'disp-menu-button',
  emits: ["dispMenu"],
  setup(__props, { emit }) {



/**
 * メニュー類表示
 */
const dispMenu = () => {
  emit("dispMenu");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "disp-menu-button",
    type: "button",
    onClick: dispMenu
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(dispMenuIcon),
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _hoisted_3
  ]))
}
}

})